import React, { useState, useEffect, FC } from 'react';
import TheatreHeader from './TheatreHeader';
import Footer from '../User/footer';
import { useLocation, useNavigate } from 'react-router';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCouch } from "@fortawesome/free-solid-svg-icons";
import { DragSourceMonitor, useDrag, useDrop } from 'react-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { saveTierData } from '../../redux/theatre/theatreThunk';
import TierConfigModal from './configModal';
import { useLastIdentifier } from '../../utils/context/identifierContext';
import { AppDispatch, RootState } from '@/redux/store/store';
export interface TierConfig {
    startLetter: string;
    order: string;
    manualLabels?: string[];
  }
  
  interface Seat {
    row: number;
    col: number;
    isFilled?: boolean;
    isPartition?: boolean;
    label?: string;
    className?:string
  }
  
  interface Tier {
    name:string,
    ticketRate:number,
    _id?:string
    rows: number;
    columns: number;
    partition: number;
    seats: number;
    seatLayout: Seat[][];
  }
  
  const ItemTypes = {
    SEAT: 'seat',
    COUCH: 'couch',
  };

const TierSeats:FC = () => {
    const { lastIdentifier, updateLastIdentifier } = useLastIdentifier();
    const location = useLocation();
    const { tier }:{tier:Tier} = location.state || {};
    console.log(tier, "tierData");
   //let fillseat=0
   const dispatch=useDispatch<AppDispatch>()
   const {theatre,isSuccess,isLoading,screens}=useSelector((state:RootState)=>state.theatre)
    const [rows, setRows] = useState<number>(tier?.rows || 0);
    const [tierConfig, setTierConfig] = useState<TierConfig>({
        startLetter: "A",
        order: "ascending", 
        manualLabels: [],    });
    
    const [columns, setColumns] = useState<number>(tier?.columns || 0);
    const [partition, setPartition] = useState<number>(tier?.partition || 0);
    const [seatGrid, setSeatGrid] = useState<Seat[][]>([]);
    const [selectedSeats, setSelectedSeats] = useState<Seat[]>([]);
    const [couchOccupied, setCouchOccupied] = useState<{[key:string]:boolean}>({});
    const [filledSeats, setFilledSeats] = useState<Seat[]>([]); 
    const[fillSeat,setFillSeat]=useState<number>(0)
    const[isConfigModalOpen,setIsConfigModalOpen]=useState<boolean>(false)
    
    const ItemTypes = {
        SEAT: 'seat',
        COUCH: 'couch', 
    };

    const getRowLabel = (index:number) => {
        let label = '';
        while (index >= 0) {
            label = String.fromCharCode(65 + (index % 26)) + label;
            index = Math.floor(index / 26) - 1;
        }
        return label;
    };

    const generateLabels = ():string[] => {
        if(!tier) return []
        const { startLetter, order, manualLabels = [] } = tierConfig;  // Provide a default empty array
      console.log(tierConfig,"tierconfig in generate label");
      
        if (manualLabels.length > 0) return manualLabels; // Use custom labels if provided
    
        let labels = [];
        console.log(lastIdentifier,"last identifier");
       // let lastTemp=lastIdentifier.charCodeAt(0)
       // console.log(lastTemp,"lasttemp");
       let storeTemp = null;


       if (tier.seatLayout && tier.seatLayout.length > 0) {
           
           for (let column of tier.seatLayout[0]) {
            
               if (column.label) {
                   
                   storeTemp = column.label.slice(0, 1);
                   break; 
               }
           }
       }
       
       console.log(storeTemp, "store temp");  
          
        let temp=storeTemp?storeTemp.charCodeAt(0):startLetter.charCodeAt(0)
        console.log(temp,"temp start letter");
            
        const startCharCode = temp// ASCII code for A or Z
        const increment = order === "ascending"&& startLetter!="Z" ? 1 : -1;
          console.log(startCharCode,increment,"startcharcode and increment");
          
        for (let i = 0; i < rows; i++) {
            labels.push(String.fromCharCode(startCharCode + i * increment));
            console.log(startCharCode,"startcharcode",increment,"increment",startCharCode+i*increment);
            
        }
        console.log(labels,"labels where returning");
      updateLastIdentifier(labels[labels.length-1])  
        return labels;
    };
    const handleConfigSave = (config:TierConfig) => {
        console.log(config,"config in tier seats modal");
        
        setTierConfig(config);
        // Close modal after saving
        setIsConfigModalOpen(false)
    }
    
    
    useEffect(() => {
        console.log(tier,"tier data check");
        if (tier && tier.seatLayout && tier.seatLayout.length > 0) {
                // If a seat layout exists in the tier, use it to initialize the grid
                setSeatGrid(
                   
                    tier.seatLayout
                );
                
                // Restore other states based on the layout, if needed
                setFilledSeats(
                    tier.seatLayout
                        .flat()
                        .filter(seat => seat.isFilled)
                        .map(seat => ({ row: seat.row, col: seat.col, label: seat.label }))
                );
                setFillSeat(
                    tier.seatLayout.flat().filter(seat => seat.isFilled).length
                );
                setCouchOccupied(
                    tier.seatLayout.flat().reduce((acc, seat) => {
                        if (seat.isFilled) acc[`${seat.row}-${seat.col}`] = true;
                        return acc;
                    }, {} as { [key: string]: boolean })
                );        }
        else{
        generateSeatGrid(rows, columns,tier.seats,partition);
        setFillSeat(0)
        setFilledSeats([])
        setCouchOccupied({})
        }
    }, [rows, columns, partition,tier]);

    const generateSeatGrid = (rows:number, columns:number,seats:number,space:number) => {
        console.log(rows,"rows",seats,"seat",space,"partition");
        
        let divColumns=Math.ceil((seats+(rows*space))/rows)
        console.log("div columns",divColumns);
        setColumns(divColumns)
        const newSeatGrid = [];
        let seatNumber=1
        for (let row = 0; row < rows; row++) {
            const rowSeats = [];
            const rowLabel = getRowLabel(row)
            let k=1
            for (let col = 0; col <divColumns; col++) {
                let tab=Math.ceil(divColumns/(space+1))
                console.log("tab",tab);
                

                rowSeats.push({ row, col, isFilled: false ,isPartition:false});
               
            }
            newSeatGrid.push(rowSeats);
            console.log(newSeatGrid,"seatgrid values in rows and columns");
            
        }
        setSeatGrid(newSeatGrid);
    };

// Implement Drag and Drop functionality
useEffect(()=>{
    // setTimeout(() => {
        
        
            if(fillSeat==tier.seats)
                {
                console.log("kkkkkkk")
        setSeatGrid((prevGrid) =>
            prevGrid.map((rowSeats, rowIndex) =>
                rowSeats.map((seat, colIndex) => {
                    const seatKey = `${rowIndex}-${colIndex}`;
                    return couchOccupied[seatKey]
                        ? seat // Keep filled seats intact
                        : { ...seat, isPartition: true }; // Mark remaining seats as partitions
                })
            )
        );
                }
    // },200);
},[fillSeat])
const openConfigModal = () => setIsConfigModalOpen(true);
    const closeConfigModal = () => setIsConfigModalOpen(false);

const Seat = React.memo(({ row, col, isFilled, isPartition,className }:Seat) => {
    const [, drop] = useDrop({
        accept: ItemTypes.COUCH,
        drop: () => {
            handleSeatClick(row,col)
            // setCouchOccupied((prev) => ({ ...prev, [`${row}-${col}`]: true }));
        },
        canDrop: () => !isPartition && !couchOccupied[`${row}-${col}`], // Check if the seat is not occupied
    });


            // console.log("vanne vanne");

    
    const handleSeatClick = (row:number, col:number) => {
        console.log("handle click worked " , row ,col , fillSeat,tier.seats)
        if (couchOccupied[`${row}-${col}`]) {
            console.log("1")

            
            console.log(fillSeat,"fillseat after undo seat");
            setCouchOccupied((prev) => {
                const updated = { ...prev };
                delete updated[`${row}-${col}`]; 
                return updated;
            });
            setSeatGrid((prevGrid) =>
                prevGrid.map((rowSeats, rowIdx) =>
                    rowSeats.map((seat, colIdx) => {
                        const seatKey = `${rowIdx}-${colIdx}`;
                        return couchOccupied[seatKey]
                            ? seat 
                            : { ...seat, isPartition: false }; 
                                            })
                )
            );
            
            setFillSeat((prev) => prev - 1); 
            setFilledSeats((prev) => prev.filter((seat) => !(seat.row === row && seat.col === col)));
        } else if (fillSeat < tier.seats) {
            
            console.log("2")
            const temp = fillSeat + 1
          

            setCouchOccupied((prev) => ({ ...prev, [`${row}-${col}`]: true }));
             setFillSeat((prev) => prev + 1);
    
            
            const updatedFilledSeats = [...filledSeats, { row, col ,isFilled:true }];
    
            
            const currentRowSeats = updatedFilledSeats
                .filter((seat) => seat.row === row)
                .sort((a, b) => a.col - b.col);
    
            
            const updatedRowSeats = currentRowSeats.map((seat, index) => ({
                ...seat,
                label: `${generateLabels()[row]}${index + 1}`, 
            }));
    
            
            const finalSeats = updatedFilledSeats
            .map((seat) => {
                if (seat.row === row) {
                    return updatedRowSeats.find((updatedSeat) => updatedSeat?.col === seat.col);
                }
                return seat;
            })
            .filter((seat): seat is Seat => seat !== undefined);
            
            setFilledSeats(finalSeats);
            
            
        } 
        console.log(fillSeat,"fillseat after filling seat \n filledSeats in array",filledSeats);
            
        
    }

    const seatLabel = filledSeats.find(seat => seat.row === row && seat.col === col)?.label || "";
 // console.log(filledSeats,"filledseat and seatlabel",seatLabel);
  
    return isPartition ? (
        <div className='w-12 h-12'></div>
    ) : (
        <div
        ref={drop}
        className={`
            cursor-pointer flex items-center justify-center 
            bg-transparent border border-yellow-500 
            ${couchOccupied[`${row}-${col}`] ? 'bg-indigo-950' : ''}
            ${className} 
            md:w-8 md:h-8 sm:w-6 sm:h-6  lg:w-12 lg:h-12  // Adjust seat size based on viewport
            `}  
        onClick={() => handleSeatClick(row, col)}
    >
            {couchOccupied[`${row}-${col}`] && (
                <>
                <FontAwesomeIcon
                    icon={faCouch}
                    size="2x"
                    className=" border-yellow-500  w-fit h-fit text-yellow-400" 
                />
                {
                 
                }
                 <span className="absolute -mt-4 z-10 text-sm  font-semibold text-blue-950">{seatLabel}</span>
                 </>
            )}
        </div>
    );
})




    const CouchLogo = () => {
        const [{ isDragging }, dragRef] = useDrag<
        { type: string }, // The type of item being dragged
        unknown,
        { isDragging: boolean } // The properties collected from monitor
    >({
        type: ItemTypes.COUCH,
        item: { type: ItemTypes.COUCH }, // Correctly define the item type here
        collect: (monitor: DragSourceMonitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });
        return (
            fillSeat<tier.seats ?
            <div className='grid-flow-col space-y-2 '>
            <div
            ref={dragRef}
            className={`cursor-pointer p-2 border-4 w-fit  border-yellow-400 rounded-md ${
              isDragging ? "opacity-50" : "opacity-100"
            }`}
          >
            <FontAwesomeIcon icon={faCouch} size="2x" color="#FFD700" />
            
          </div>
          <div className="text-yellow-500 "> Seats left: {tier.seats - fillSeat}</div>
          </div>:null
        );
    };
    const handleSubmit = (e:React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();


        
    };

    const handleRowsChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        setRows(parseInt(e.target.value, 10));
    };



    const handlePartitionChange = (e:React.ChangeEvent<HTMLInputElement>) => {
        setPartition(parseInt(e.target.value, 10));
    };
    const handleSaveConfiguration = () => {
        const seatsData = seatGrid.map((rowSeats, rowIndex) => 
            rowSeats.map((seat, colIndex) => {
                const seatKey = `${rowIndex}-${colIndex}`;
                const isFilled = couchOccupied[seatKey] ? true : false;
                const isPartition = seat.isPartition;
    
                // Find label for the current seat based on exact row and column match
                const filledSeat = filledSeats.find(s => s.row === rowIndex && s.col === colIndex);
                const label = filledSeat && !isPartition ? filledSeat.label : ""; // Only assign label if not a partition
    
                let status = "available";
                if (isPartition) {
                    status = "partition";
                } else if (isFilled) {
                    status = "available";  
                }
    
                return {
                    row: rowIndex,    // Store row and column for reference
                    col: colIndex,
                    label: label,
                    isFilled: isFilled,
                    isPartition: isPartition,
                    status: status
                };
            })
        );
    
        const updatedTier = {
            ...tier,
            rows,
            columns,
            partition,
            seatLayout: seatsData  // Store seatsData in seatLayout field
        };
    
        console.log(updatedTier, "Updated Tier", filledSeats, "Filled Seats");
    
        saveTierConfig(updatedTier);
    };
    const navigate=useNavigate()
    const saveTierConfig = async (tierData:Tier) => {
        console.log(screens,"screens for in redux state");
        
        const screen = screens.find((screen) =>
            screen.tiers.some((tier) => tier._id === tierData._id)
        );
    console.log(screen,"data screen");
    
        
        const screenId = screen?._id??""
        console.log(screenId);
        
        dispatch(saveTierData({tierData,screenId}))
        navigate(-1)
    };
        
    
    return (
        <>
            <TheatreHeader />
            <div className=" min-h-screen flex" style={{backgroundColor:"#FEE685"}}>
                <div className="flex-col p-2 m-4 bg-slate-900 w-full mx-20 rounded-lg justify-between text-white">
                    <h1 className="p-2 justify-center text-center text-2xl">Seats Management</h1>
                    <div className="flex justify-start flex-col text-lg font-mono gap-4 text-white">
                        <span>Name: {tier.name}</span>
                        <span>Ticket Rate: {tier.ticketRate}</span>
                        <span>Seats: {tier.seats}</span>
                       <div className='flex justify-start items-center'>
                        <CouchLogo/>
                       </div>
                    </div>
                    <form onSubmit={handleSubmit} className="mx-4 mt-12 items-end space-y-4">
                        
                        <div className="flex items-center gap-6">
                            <div className="flex flex-1 items-center gap-4">
                                <label className="text-md font-medium min-w-fit mb-4">No of Rows</label>
                                <input
                                    type="number"
                                    value={rows}
                                    onChange={handleRowsChange}
                                    className="w-full p-3 mb-4 rounded-lg bg-black border border-amber-400 focus:border-amber-500 outline-none"
                                />
                            </div>
                            {/* <div className="flex flex-1 items-center gap-4">
                                <label className="text-md font-medium min-w-fit mb-4">No of Columns</label>
                                <input
                                    type="number"
                                    value={columns}
                                    onChange={handleColumnsChange}
                                    className="w-full p-3 mb-4 rounded-lg bg-black border border-amber-400 focus:border-amber-500 outline-none"
                                />
                            </div> */}
                            <div className="flex items-center gap-4">
                                <label className="text-md min-w-fit font-medium mb-4">Horizontal Partition</label>
                                <input
                                    type="number"
                                    value={partition}
                                    onChange={handlePartitionChange}
                                    className="w-full p-3 mb-4 rounded-lg bg-black border border-amber-400 focus:border-amber-500 outline-none"
                                />
                            </div>
                        </div>

                       

<div className="mt-10 flex flex-col gap-[5px]">
<div className="flex justify-start mt-8">
                            <button
                                type="button"
                                onClick={openConfigModal}
                                className="bg-amber-400 min-h-8 w-fit h-fit text-indigo-950 rounded p-2 hover:bg-yellow-500"
                            >
                                identifier configure
                            </button>
                        </div>
                        {/* {console.log(seatGrid,"seatGrid") */}


{seatGrid.map((rowSeats, rowIndex) => {
                    const rowLabel = generateLabels()[rowIndex];
                    return (
                        <div key={rowIndex} className="flex justify-center items-center mb-4">
                            {filledSeats.some(seat => seat.row === rowIndex) && (
                                <div className="text-white w-12 h-12 flex justify-center items-center">
                                    {rowLabel}
                                </div>
                            )}
                            <div className="flex gap-[5px]">
                                {rowSeats.map((seat, colIndex) => (
                                    <Seat
                                        key={`${rowIndex}-${colIndex}`}
                                        row={rowIndex}
                                        col={colIndex}
                                        isFilled={seat.isFilled}
                                        isPartition={seat.isPartition}
                                        className={` ${
                                            seat.isFilled ? 'bg-gray-200' : ''
                                          }`} 
                                    />
                                ))}
                            </div>
                        </div>
                    );
                })}
    
</div>


                        <div className="flex justify-center mt-8 p-4">
                            <button
                                type="submit"
                                onClick={handleSaveConfiguration}
                                className="items-center rounded min-w-fit p-2 min-h-8 bg-amber-400 text-base text-indigo-950 hover:text-sm hover:bg-yellow-500"
                            >
                                Save
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <Footer />
            {isConfigModalOpen && (
    <TierConfigModal
        onSave={handleConfigSave}
        onCancel={() => setIsConfigModalOpen(false)}
        initialConfig={tierConfig}
    />
)}

        </>
    );
};

export default TierSeats;




